import { useCallback, useMemo } from 'react';
import { useField } from 'react-final-form';

import { RetailerNetworkPartialFragment } from '@occc/graphql';
import { LazyAutocompleteField } from '@occc/ui-design-system';

import {
  makeRetailerNetworkFilter,
  mapRetailerNetworksResponseToRawArray,
  mapRetailerNetworkToAutocompleteOption,
} from './retailer-network-autocomplete.helpers';

import { useGetRetailerNetworksForUserLazyQuery } from '../../data-access/queries';

type RetailerNetworkMultipleSelectFieldProps = {
  name: string;
  label?: string;
};

export const RetailerNetworkMultipleSelectField = (
  props: RetailerNetworkMultipleSelectFieldProps,
) => {
  const {
    input: { value },
  } = useField<RetailerNetworkPartialFragment[] | undefined>(props.name);

  const selectedUuids = useMemo(
    () => (value || []).map((retailerNetwork) => retailerNetwork.uuid),
    [value],
  );

  const makeQueryFilter = useCallback(
    (search: string) => makeRetailerNetworkFilter({ search, uuidExcludes: selectedUuids }),
    [selectedUuids],
  );

  return (
    <LazyAutocompleteField<
      RetailerNetworkPartialFragment,
      ReturnType<typeof useGetRetailerNetworksForUserLazyQuery>['response']
    >
      label='Retailer Networks'
      {...props}
      makeQueryFilter={makeQueryFilter}
      excludeSelectedItems
      useLazyQuery={useGetRetailerNetworksForUserLazyQuery}
      mapQueryResponseToRawArray={mapRetailerNetworksResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRetailerNetworkToAutocompleteOption}
    />
  );
};
